import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import {
  HeaderH2,
  HeaderH1,
  Text,
  NextButton,
  ImageBlock,
} from "components/TextBlocks";
import {
  AddNote,
  FullScreen,
  MoveIcon,
  OpenIcon,
  TrashIcon,
  AddIcon,
} from "components/IconBlocks";

function OpenCloseAll(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Open all sites</HeaderH1>
      <Text>
        When your group contains any number of sites you can open them all in
        one click using the open/close all button. The sites will open in a tab
        group.
      </Text>
      <ImageBlock
        src={"/guide/open_group.png"}
        width={504}
        height={292}
        quality={100}
        alt={"Change username"}
      />
      <Text>
        After you have opened your tabs you can also close them all in one
        click.
      </Text>
      <ImageBlock
        src={"/guide/close_group.png"}
        width={504}
        height={292}
        quality={100}
        alt={"Change username"}
      />
      <Text>
        See more about tab groups and what you can do with them at{" "}
        <a href="https://blog.google/products/chrome/manage-tabs-with-google-chrome/">
          blog.google/products/chrome/manage-tabs-with-google-chrome
        </a>
      </Text>
      <NextButton
        cta={"Group options"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/group-options"}
      />
    </>
  );
}

OpenCloseAll.Layout = SideBar;

export default OpenCloseAll;
